import { checkArrayOnlyType, checkObject } from 'libs/types/checkTypes';
import User from '../constants/user';

/**
 * @function filterSDSSupport
 * @desc Filters an array of users based on the SDSSupportUsername condition.
 * @param {UserList[]} users The array of users to filter.
 * @param {UserInfo} userInfo  The user information object.
 * @returns {UserList[]} The filtered array of users.
 */
function filterSDSSupport(users, userInfo) {
	checkArrayOnlyType(users);
	checkObject(userInfo);

	let results = Array.from(users);

	if (userInfo.UserName !== User.SDSSupportUsername) {
		results = users.filter((user) => user.username !== User.SDSSupportUsername);
	}

	return results;
}

export default filterSDSSupport;
